if (!customElements.get('ace-sticky-member-notice')) {
  customElements.define('ace-sticky-member-notice', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.ace-member-announcement-section');
      if (!this.section) return;
      this.controller = new AbortController();
      this.scheduleHeight = () => {
        cancelAnimationFrame(this.heightFrame);
        this.heightFrame = requestAnimationFrame(() => this.publishHeight());
      };
      this.sizeObserver = new ResizeObserver(this.scheduleHeight);
      this.sizeObserver.observe(this.section);
      window.addEventListener('resize', this.scheduleHeight, { passive: true, signal: this.controller.signal });
      window.addEventListener('pageshow', this.scheduleHeight, { signal: this.controller.signal });
      this.publishHeight();
    }
    publishHeight() {
      if (!this.isConnected || !this.section) return;
      const height = Math.ceil(this.section.getBoundingClientRect().height);
      const root = document.documentElement;
      const value = height + 'px';
      if (root.style.getPropertyValue('--ace-sticky-announcement-height') === value) return;
      root.style.setProperty('--ace-sticky-announcement-height', value);
      document.dispatchEvent(new CustomEvent('ace:announcement-resize', { detail: { height } }));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.sizeObserver?.disconnect();
      cancelAnimationFrame(this.heightFrame);
      const remaining = document.querySelector('ace-sticky-member-notice');
      if (remaining && remaining !== this && remaining.isConnected) {
        remaining.publishHeight?.();
      } else {
        document.documentElement.style.removeProperty('--ace-sticky-announcement-height');
        document.dispatchEvent(new CustomEvent('ace:announcement-resize', { detail: { height: 0 } }));
      }
    }
  });
}
